import { useCallback, useMemo } from "react";
import { headerSlugs, practiceSlugs } from "../../utils/commonRouteUrl";

function useUpgradePlanHook(
  item: any,
  subscriptionType: string | undefined,
  setPremiumMonthUpgradeModal: any,
  setProMonthUpgradeModal: any,
  isAdmin: boolean,
  isAuth?: any,
  closeHeaderSearchDropdown?: any,
) {
  // for User Pro Plan
  const isProSubscription = useMemo(() => {
    return subscriptionType === "PRO" || subscriptionType === "PRO_MONTH";
  }, [subscriptionType]);

  // for User Premium Plan
  const isPremiumSubscription = useMemo(() => {
    return subscriptionType === "PREMIUM" || subscriptionType === "PREMIUM_MONTH";
  }, [subscriptionType]);

  // for Form Pro Plan
  const isProPlan = useMemo(() => {
    return item?.plan?.toString() === "pro";
  }, [item?.plan]);

  // for Form Premium Plan
  const isPremiumPlan = useMemo(() => {
    return item?.plan?.toString() === "premium";
  }, [item?.plan]);

  // for Form Basic Plan
  const isBasicPlan = useMemo(() => {
    return item?.plan?.toString() === "basic";
  }, [item?.plan]);

  // for Form User Plan
  const isUserPlan = useMemo(() => {
    return item?.plan?.toString() === "";
  }, [item?.plan]);

  // for Form Pro or Premium Plan
  const isProAndPremiumFormPlan = useMemo(() => {
    return isProPlan || isPremiumPlan;
  }, [isPremiumPlan, isProPlan]);

  const accessReviverPageCard = useMemo(() => {
    return (isAdmin || (isProAndPremiumFormPlan && isProSubscription) || isBasicPlan || (isPremiumPlan && isPremiumSubscription) || isUserPlan) && isAuth;
  }, [isAdmin, isAuth, isBasicPlan, isPremiumPlan, isPremiumSubscription, isProAndPremiumFormPlan, isProSubscription, isUserPlan]);

  const reviewerPageAccessCard = useCallback(() => {
    if (!isAuth && isBasicPlan) {
      window.location.replace(`${headerSlugs?.login}?planType=BASIC&redirectPlanUrl=${practiceSlugs?.previewTemplate(item?.id?.toString() ?? "")}`);
    } else if (accessReviverPageCard && isAuth) {
      window.location.replace(`${practiceSlugs?.previewTemplate(item?.id?.toString() ?? "")}`);
      closeHeaderSearchDropdown();
    }
  }, [accessReviverPageCard, closeHeaderSearchDropdown, isAuth, isBasicPlan, item?.id]);

  const reviewerPageUpgradeModal = useCallback(() => {
    if (!isAdmin) {
      if (
        isPremiumPlan &&
        !(subscriptionType === "PREMIUM" || subscriptionType === "PREMIUM_MONTH" || subscriptionType === "PRO" || subscriptionType === "PRO_MONTH")
      ) {
        setPremiumMonthUpgradeModal(true);
      } else if (isProPlan && !isProSubscription) {
        setProMonthUpgradeModal(true);
      }
    }
  }, [isAdmin, isPremiumPlan, isProPlan, isProSubscription, setPremiumMonthUpgradeModal, setProMonthUpgradeModal, subscriptionType]);

  return {
    reviewerPageAccessCard,
    reviewerPageUpgradeModal,
    accessReviverPageCard,
  };
}

export default useUpgradePlanHook;
